import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

const columnStyles = {
  reference_id: { width: '40px !important' },
  fullName: { width: '40px !important' },
  email: { width: '40px !important' },
  mobile: { width: '40px !important' },
  status: { width: '40px !important' },
  actions: { width: '40px !important', textAlign: 'center' },
};

const AuditorsTable = ({ auditors, onEdit, onDelete }) => {
  const columns = [
    {
      dataField: 'reference_id',
      text: 'Reference ID',
      sort: true,
      headerStyle: () => columnStyles.reference_id,
      style: columnStyles.reference_id,
      formatter: (cell, row) => cell || (row.primary_id ? `AUD${row.primary_id}` : 'N/A'),
    },
    {
      dataField: 'fullName',
      text: 'Full Name',
      sort: true,
      headerStyle: () => columnStyles.fullName,
      style: columnStyles.fullName,
      formatter: (cell, row) => {
        const firstName = row.first_name || '';
        const lastName = row.last_name || '';
        return `${firstName} ${lastName}`.trim() || 'N/A';
      },
    },
    {
      dataField: 'email',
      text: 'Email',
      sort: true,
      headerStyle: () => columnStyles.email,
      style: columnStyles.email,
      formatter: (cell) => cell || 'N/A',
    },
    {
      dataField: 'mobile',
      text: 'Mobile',
      sort: true,
      headerStyle: () => columnStyles.mobile,
      style: columnStyles.mobile,
      formatter: (cell) => {
        if (!cell) return 'N/A';
        const countryCode = cell.country_code ? `+${cell.country_code}` : '';
        const number = cell.number || '';
        return `${countryCode} ${number}`.trim() || 'N/A';
      },
    },
    {
      dataField: 'status',
      text: 'Status',
      sort: true,
      headerStyle: () => columnStyles.status,
      style: columnStyles.status,
      formatter: (cell) => (cell ? 'Active' : 'Inactive'),
    },
    {
      dataField: 'actions',
      text: 'Actions',
      headerStyle: () => columnStyles.actions,
      style: columnStyles.actions,
      formatter: (cell, row) => (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
          <IconButton onClick={() => onEdit(row)} title="Edit" size="small">
            <FeatherIcon icon="edit" size={18} />
          </IconButton>
          <IconButton onClick={() => onDelete(row)} title="Delete" size="small">
            <FeatherIcon icon="trash-2" size={18} color="red" />
          </IconButton>
        </Box>
      ),
    },
  ];

  const paginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const NoDataIndication = () => (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="45vh" width="100%">
      <Box textAlign="center" py={4}>
        <FeatherIcon icon="inbox" size={40} style={{ opacity: 0.5, marginBottom: '16px' }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          There are no auditors to display
        </Typography>
      </Box>
    </Box>
  );

  const tableStyles = {
    minHeight: '50vh',
    maxHeight: '70vh',
    overflow: 'auto',
    borderRadius: 1,
    boxShadow: 1,
    position: 'relative',
    zIndex: 1,
    '& .react-bootstrap-table': {
      minHeight: '45vh'
    },
    '& table': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      tableLayout: 'fixed',
      width: '100%'
    },
    '& thead th': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#f8f9fa',
      zIndex: 2,
      borderBottom: '2px solid #dee2e6',
      padding: '12px 8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& tbody td': {
      padding: '10px 8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& tbody tr:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
    '& .pagination': {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '16px',
      borderTop: '1px solid #dee2e6',
    }
  };

  return (
    <Paper sx={{
      ...tableStyles,
      '& thead th:nth-of-type(1)': {
        width: '100px !important',
      },
      '& thead th:nth-of-type(2)': {
        width: '150px !important',
      },
      '& thead th:nth-of-type(3)': {
        width: '200px !important',
      },
      '& thead th:nth-of-type(4)': {
        width: '150px !important',
      },
      '& thead th:nth-of-type(5)': {
        width: '200px !important',
      },
      '& thead th:nth-of-type(6)': {
        width: '100px !important',
      },
      '& thead th:nth-of-type(7)': {
        width: '120px !important',
      }
    }} className="miui-table scrollable-table">
      <BootstrapTable
        keyField="_id"
        data={auditors || []}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        bootstrap4
        bordered={false}
        hover
        noDataIndication={NoDataIndication}
        wrapperClasses="table-responsive"
      />
    </Paper>
  );
};

export { AuditorsTable };